/* Packin Pixie homepage behaviour. Vanilla JS, no dependencies. Safe to load more than once. */
(function () {
  if (window.__ppHome) return;
  window.__ppHome = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* ---------- Sticky header: compact + cream blur after scrolling ---------- */
    var header = document.querySelector('[data-pp-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 10); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---------- Mobile menu drawer ---------- */
    var drawer = document.querySelector('[data-pp-drawer]');
    var openBtn = document.querySelector('[data-pp-menu-open]');
    if (drawer && openBtn) {
      var closeBtn = drawer.querySelector('[data-pp-menu-close]');
      var setMenu = function (open) {
        drawer.classList.toggle('open', open);
        drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
        openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.style.overflow = open ? 'hidden' : '';
        if (open) { (closeBtn || drawer).focus(); } else { openBtn.focus({ preventScroll: true }); }
      };
      openBtn.addEventListener('click', function () { setMenu(true); });
      if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
      drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
      document.addEventListener('keydown', function (e) {
        if (!drawer.classList.contains('open')) return;
        if (e.key === 'Escape') { setMenu(false); return; }
        if (e.key === 'Tab') {
          var f = drawer.querySelectorAll('a[href],button:not([disabled])');
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }

    /* ---------- Header cart icon: the theme's cart drawer binds to .m-cart-icon-bubble itself.
       Only if the drawer is missing do we fall back to the normal /cart link (no JS needed). ---------- */

    /* ---------- Real add-to-bag (AJAX /cart/add.js) ----------
       Runs after the store's processing-time consent popup (that script stops the first submit and
       re-submits once the shopper agrees). Then hands the added item to the theme so its cart drawer
       and count refresh exactly as they do on product pages. */
    var cartDrawerOn = !!(window.MinimogSettings && MinimogSettings.enable_cart_drawer);

    function updateCounts() {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('[data-pp-count]').forEach(function (el) { el.textContent = c.item_count; el.classList.toggle('hidden', c.item_count === 0 && el.classList.contains('hidden')); });
          document.querySelectorAll('[data-pp-cart]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + c.item_count + ' items'); });
        }).catch(function () {});
    }

    var toastHost, toastTimer;
    function toast(msg) {
      if (!toastHost) {
        toastHost = document.createElement('div');
        toastHost.className = 'pp pp-toast-host';
        toastHost.style.background = 'transparent';
        toastHost.innerHTML = '<div class="toast" role="status" aria-live="polite"><svg class="i" viewBox="0 0 100 100" aria-hidden="true"><path fill="currentColor" d="M50 0C54 33 67 46 100 50 67 54 54 67 50 100 46 67 33 54 0 50 33 46 46 33 50 0Z"/></svg><span></span></div>';
        document.body.appendChild(toastHost);
      }
      var t = toastHost.querySelector('.toast');
      t.querySelector('span').textContent = msg;
      t.classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-pp-atc')) return;
      e.preventDefault();
      var btn = form.querySelector('[name="add"]');
      var err = form.parentNode.querySelector('.pp-err');
      if (!btn || btn.classList.contains('is-loading')) return;
      var label = btn.getAttribute('data-label') || btn.innerHTML;
      btn.setAttribute('data-label', label);
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      if (err) err.textContent = '';

      var drawer = document.querySelector('m-cart-drawer');
      var fd = new FormData(form);
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        var ids = drawer.getSectionsToRender().map(function (x) { return x.id; });
        fd.append('sections', ids.filter(function (v, i) { return ids.indexOf(v) === i; }).join(','));
        fd.append('sections_url', location.pathname);
      }
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: fd
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          if (!res.ok || res.j.status) {
            if (err) err.textContent = res.j.description || res.j.message || 'Sorry, this item could not be added. Please try again.';
            return;
          }
          btn.classList.add('is-added');
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; }, 2400);
          var name = form.getAttribute('data-pp-name') || res.j.product_title || 'item';
          var opened = false;
          try {
            if (cartDrawerOn && drawer && typeof drawer.renderContents === 'function' && res.j.sections) { drawer.renderContents(res.j); opened = true; }
            if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, res.j);
          } catch (x) {}
          updateCounts();
          if (!opened) toast('Added to bag: ' + name);
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          if (err) err.textContent = 'Connection problem. Please try again.';
        });
    });

    /* ---------- Holiday bundle picker (desktop + mobile chip sets stay in sync) ---------- */
    document.querySelectorAll('[data-pp-bundle]').forEach(function (sec) {
      var chips = sec.querySelectorAll('[data-pp-chip]');
      var all = function (sel, fn) { sec.querySelectorAll(sel).forEach(fn); };
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var d; try { d = JSON.parse(chip.getAttribute('data-pp-chip')); } catch (x) { return; }
          var i = chip.getAttribute('data-pp-chip-i');
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-pp-chip-i') === i ? 'true' : 'false'); });
          all('[data-pp-bundle-link]', function (link) {
            link.href = d.url;
            var img = link.querySelector('img');
            if (img) { img.srcset = d.srcset; img.src = d.img; img.alt = d.title; }
          });
          all('[data-pp-bundle-hero]', function (link) {
            link.href = d.url;
            var img = link.querySelector('img');
            if (img && d.pimg) { img.srcset = d.psrcset || ''; img.src = d.pimg; img.alt = d.palt || d.title; }
          });
          all('[data-pp-bundle-guide]', function (a) { if (d.full) a.href = d.full; });
          all('[data-pp-bundle-cta]', function (cta) { cta.href = d.url; });
          (d.tiers || []).forEach(function (t, n) {
            all('[data-pp-tier-link="' + n + '"]', function (a) { a.href = t.url; });
            all('[data-pp-tier-price="' + n + '"]', function (p) { p.textContent = t.price; });
          });
        });
      });
    });

    /* ---------- Gentle lift-in for below-the-fold blocks (content visible without JS) ---------- */
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.remove('pre'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -6% 0px' });
      document.querySelectorAll('.pp .rv').forEach(function (el, i) {
        if (el.getBoundingClientRect().top > window.innerHeight) {
          el.classList.add('pre');
          el.style.transitionDelay = ((i % 3) * 80) + 'ms';
          io.observe(el);
        }
      });
    }

    /* ---------- Email form: scroll back to the message after Shopify's post/redirect ---------- */
    if (/customer_posted=true/.test(location.search) || location.hash === '#PPNewsletter') {
      var msg = document.getElementById('PPNewsletterMsg');
      if (msg) msg.scrollIntoView({ block: 'center' });
    }
  });
})();
